import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface WhatsappModel extends BaseModel {
  variables?: { [key: string]: string } | WhatsappVariables;
}

export interface WhatsappVariables {
  WhatsappImage: string;
  WhatsappText: string;
  WhatsappCtaText: string;
  WhatsappCtaLink: string;
}

export class WhatsappInitVariables implements WhatsappVariables {
  WhatsappImage = '';
  WhatsappText = '';
  WhatsappCtaText = '';
  WhatsappCtaLink = '';
}

export class WhatsappInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new WhatsappInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
